import { useComposedRefs } from '@Page/Onboarding/hooks/useComposedRefs';
import { useRef, useState } from 'react';

type ValidatedFormProps = React.FormHTMLAttributes<HTMLFormElement> & React.RefAttributes<HTMLFormElement>;

export function useValidatedForm(props: ValidatedFormProps) {
    const ref = useRef<HTMLFormElement>(null);
    const formRef = useComposedRefs(ref, props.ref);

    const [formIsValid, setFormIsValid] = useState(true);

    function checkInvalid() {
        const fields = Array.from(ref.current?.elements ?? []);
        const invalid = fields.find((element) => {
            return hasElementValidityProperty(element) && !element.validity.valid;
        });
        if (invalid) {
            setFormIsValid(false);
        } else {
            setFormIsValid(true);
        }
    }

    function onBlur(e: React.FocusEvent<HTMLFormElement>) {
        checkInvalid();
        props.onBlur?.(e);
    }

    // We only want this to check when select element changes..
    function onChange(e: React.ChangeEvent<HTMLFormElement>) {
        if (e.target instanceof HTMLSelectElement) {
            checkInvalid();
            props.onChange?.(e);
        }
    }

    function onInvalid(e: React.FormEvent<HTMLFormElement>) {
        checkInvalid();
        props.onInvalid?.(e);
    }

    return {
        formIsValid,
        formProps: {
            ...props,
            ref: formRef,
            onBlur,
            onChange,
            onInvalid,
        },
    };
}

export function hasElementValidityProperty(
    element: Element | RadioNodeList | null,
): element is HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement {
    return (
        element instanceof HTMLInputElement ||
        element instanceof HTMLSelectElement ||
        element instanceof HTMLTextAreaElement
    );
}
